export const POPUP_TEXT = {
  CONFIRM_DEFAULTS: {
    dialogTitle: '',
    dialogText: '',
    confirmBtntext: 'Yes',
    declineBtnText: 'Back',
    customCssClass: 'title-paddings'
  },
  DELETE_COLLECTION: {
    dialogTitle: 'Delete Collection',
    dialogText: 'Are you sure you want to delete this collection permanently?',
    confirmBtntext: 'Yes',
    declineBtnText: 'Back',
    customCssClass: 'title-paddings'
  },
  DELETE_MODEL: {
    dialogTitle: 'Delete Model',
    dialogText: 'This model will be deleted from Your Library.',
    confirmBtntext: 'Yes',
    declineBtnText: 'Back',
    customCssClass: 'title-paddings'
  },
  REMOVE_MODEL_FROM_COLLECTION: {
    dialogTitle: 'Remove Model',
    dialogText: 'Do you want to delete this model from this collection?',
    confirmBtntext: 'Yes',
    declineBtnText: 'Back',
    customCssClass: 'title-paddings'
  },
  DELETE_ACCOUNT: {
    dialogTitle: 'Delete Account',
    dialogText: 'Your account will be deleted permanently.',
    confirmBtntext: 'Yes',
    declineBtnText: 'Back',
    customCssClass: 'title-paddings'
  },
  SHARED_CONTENT_NOT_AVAILABLE: {
    dialogTitle: 'Shared with You',
    dialogText: '{contentType} is no longer available.',
    declineBtnText: 'Back',
    customCssClass: 'title-paddings',
    singleButton: true
  },
  UPLOAD_ERROR: {
    dialogTitle: 'Upload Error',
    dialogText: '{message}',
    confirmBtntext: 'Mark as Read',
    declineBtnText: 'Back',
    customCssClass: 'title-paddings'
  },
  UPLOAD_ERROR_MOBILE: {
    dialogTitle: '',
    dialogText: 'Model "{modelTitle}". {details}, please contact support.',
    confirmBtntext: 'Mark as Read',
    declineBtnText: 'Back',
    customCssClass: 'title-paddings'
  },
  UPLOAD_UNSUPPORTED_FORMAT_MESSAGE: 'Supported model format not found. Please upload usdz or fbx.',
  MISSING_TEXTURES: {
    dialogTitle: 'Missing Textures',
    dialogText: 'Model "{modelTitle}" is missing texture files. Please use the web version to upload missing textures.',
    confirmBtntext: 'OK',
    declineBtnText: 'Cancel',
    customCssClass: 'title-paddings'
  },
  DOWNLOAD_SWITCH: {
    dialogTitle: 'Cancel current download?',
    dialogText: 'You are currently downloading "{currentModelName}". Do you want to cancel it and start downloading "{newModelName}" instead?',
    confirmBtntext: 'Cancel',
    declineBtnText: 'Back'
  },
  DOWNLOAD_CANCEL: {
    dialogTitle: 'Cancel download?',
    dialogText: 'You are currently downloading "{modelName}". Do you want to cancel the download to {action}?',
    confirmBtntext: 'Cancel',
    declineBtnText: 'Back'
  },

   // SERVICE POPUPS ONLY FOR DEV PURPOSES

  AI_DESCRIPTION: {
    dialogTitle: 'AI Description',
    dialogText: '{shortDescription}',
    technicalDescription: '{technicalDescription}',
    confirmBtntext: 'Ok',
    declineBtnText: 'Back'
  },
  AI_COLLECTION_DESCRIPTION: {
    dialogTitle: 'AI Collection Description',
    dialogText: '{shortDescription}',
    technicalDescription: '{technicalDescription}',
    confirmBtntext: 'Apply',
    declineBtnText: 'Back'
  },
    DELETE_ALL_MODELS: {
    dialogTitle: 'Are you sure?',
    dialogText: 'Do you want to delete all models? ',
    confirmBtntext: 'Yes',
    declineBtnText: 'Back'
  },

  // OUTDATE --- IGNORE --- //

    SUBSCRIPTION_PROCEED: {
    dialogTitle: 'Are you sure?',
    dialogText: 'You have unfinished uploading models for rendering, are you sure you want to proceed for subscription right now?',
    confirmBtntext: 'Yes',
    declineBtnText: 'Back'
  },

    MAKE_COLLABORATIVE: {
    dialogTitle: 'Make collaborative?',
    dialogText: 'You remain owner and can edit collaborators list.',
    confirmBtntext: 'Yes',
    declineBtnText: 'Back'
  },
  MAKE_NON_COLLABORATIVE: {
    dialogTitle: 'Make non-collaborative?',
    dialogText: 'Models of collaborators will be deleted.',
    confirmBtntext: 'Yes',
    declineBtnText: 'Back'
  },
  REMOVE_COLLABORATOR: {
    dialogTitle: 'Remove collaborator?',
    dialogText: 'All models of this collaborator will also be deleted.',
    confirmBtntext: 'Yes',
    declineBtnText: 'Back'
  },
  CANCEL_PUBLISHING: {
    dialogTitle: 'Cancel Publishing',
    dialogText: 'Are you sure you want to cancel publishing model "{modelTitle}" ? ',
    confirmBtntext: 'Yes',
    declineBtnText: 'Back'
  },
  CANCEL_PUBLISHING_NO_TITLE: {
    dialogTitle: '',
    dialogText: 'Are you sure you want to cancel publishing model "{modelTitle}" ? ',
    confirmBtntext: 'Yes',
    declineBtnText: 'Back'
  },
  REVIEW_STATUS_REJECTED: {
    dialogTitle: 'Review Status',
    dialogText: 'Thank you for the submission. We will reply to your e-mail with rejection reason and next steps soon.',
    confirmBtntext: 'OK',
    customCssClass: 'title-paddings',
    singleButton: true
  },

  WEB_DIALOG_ANDROID_SUPPORT_INFO: {
    heading: 'Information',
    mainBtnTitle: 'Ok',
    inputPlaceHolder: '',
    inputValue: 'Android support is coming soon.\nPlease use our 3DWay desktop version.',
    isInputHidden: true
  },

  // SYTEM CONFIRM MESSAGES ONLY IN CHROME, OTHER BROWSERS USE DEFAULT CONFIRM DIALOGS

  SYSTEM_CONFIRM_MESSAGES: {
    CLOSE_MISSING_TEXTURES_UPLOAD: 'Close this dialog will cancel upload, are you sure?',
    ABORT_MISSING_TEXTURES_UPLOAD: 'Abort upload and cancel rendering this model?',
    // SERVCIE SETTINGS DEV ONLY
    DELETE_ALL_RATINGS: 'Are you sure you want to delete all your ratings? This action cannot be undone.',
    CLEAR_COMMENT: 'Are you sure you want to clear this comment?'
  },

};
